import type { Robot } from '$lib/patterns/strategy/examples/types';
type Message = Robot.Message;
import type { Caching } from './shared/strategy/Cached_API'
import type { Get_Content } from './shared/strategy/Content';

import { Dad_Joke, Stoicism_Quote, Comedian_Joke } from './shared/strategy/Content';
import { Cached_Message, Uncached_Message } from './shared/strategy/Cached_API';








abstract class Chatbot {

	abstract readonly name: string;
	abstract readonly avatar: string;
	public abstract message: Get_Content;
	public abstract cache: Caching;


	async getMessage(): Promise<Message> {
		return {
			author: this.name,
			avatar: this.avatar,
			content: await this.message.getContent(),
			log: this.cache.getStatusUpdate(),
			time: new Date().toLocaleTimeString(),
		}
	}
}

class Comedian_Bot extends Chatbot {
	readonly name = 'Comedian Joke';
	readonly avatar = 'comedian-bot';
	readonly description = 'Best jokes by the best comedians.';
	public message = new Comedian_Joke();
	public cache = new Uncached_Message(this.name);
}

class Dad_Joke_Bot extends Chatbot {
	readonly name = 'Dad Joke Bot';
	readonly avatar = 'dad-bot';
	readonly description = 'Dad jokes are very punny.';
	
	public message = new Dad_Joke();
	public cache = new Cached_Message(this.name);
}

class Stoicism_Bot extends Chatbot {
	readonly name = 'Stoicism Bot';
	readonly avatar = 'stoicism';
	readonly description = "Listening to this bot is the beginning of all wisdom.";
	public message = new Stoicism_Quote();
	public cache = new Cached_Message(this.name);
}

export default {
	Chatbot: {
		class: Chatbot,
	},
	Stoicism_Bot: {
		class: Stoicism_Bot,
		init: () => new Stoicism_Bot(),
	},
	Dad_Joke_Bot: {
		class: Dad_Joke_Bot,
		init: () => new Dad_Joke_Bot(),
	},
	Comedian_Bot: {
		class: Comedian_Bot,
		init: () => new Comedian_Bot(),
	},
}
